export default __webpack_public_path__ + "static/media/green-eyes.910c4371.png";